// Central feature flags. Enable/disable large product surfaces without touching
// dozens of components. Read at build time from process.env so it's cacheable
// and doesn't require server round-trips.
//
// Rule: default is "monetization OFF" for the MVP. To re-enable in production
// set REACT_APP_MONETIZATION=true in the frontend .env.
export const FEATURES = {
  monetization:
    (process.env.REACT_APP_MONETIZATION || "").toString().toLowerCase() === "true",
};

export const MONETIZATION_ENABLED = FEATURES.monetization;
